// ============================================================================
// ENGINEER MANPOWER PAGE - WRAPPER FOR MANPOWER DASHBOARD
// This component wraps the existing ManpowerDashboard for engineers
// ============================================================================

import React from 'react';
import { AuthUser } from '../../../services/auth.service';
import ManpowerDashboard from '../../dashboard/pages/ManpowerDashboard';

interface EngineerManpowerPageProps {
  user?: AuthUser;
  onNavigate: (page: string, params?: string) => void;
}

const EngineerManpowerPage: React.FC<EngineerManpowerPageProps> = ({ 
  user,
  onNavigate 
}) => {
  console.log('🏗️ Engineer Manpower Page: Rendering for', user?.name);

  // Check if user has manpower access
  if (!user?.manpowerAccess) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: '40px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          🚫
        </div>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '12px'
        }}>
          Access Denied
        </h2>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          marginBottom: '24px'
        }}>
          You don't have permission to access Manpower features.
        </p>
        <button
          onClick={() => onNavigate('dashboard')}
          style={{
            padding: '10px 24px',
            background: '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Back to Dashboard
        </button>
      </div>
    );
  }

  // Render the existing ManpowerDashboard component
  return (
    <ManpowerDashboard
      onBack={() => onNavigate('dashboard')}
      onNavigate={onNavigate}
      user={user}
      initialManagerId={user?.uid || user?.employeeNo || user?.employeeNumber}
    />
  );
};

export default EngineerManpowerPage;